export const Marquee = () => {
  const items = [
    "Product Design",
    "Design Systems",
    "Editorial",
    "Brand Identity",
    "Interaction",
    "Wayfinding",
    "Research",
    "Prototype",
  ];
  const loop = [...items, ...items];
  return (
    <section
      aria-hidden
      data-testid="marquee"
      className="relative border-y border-black/10 py-6 md:py-8 overflow-hidden bg-[#F4F4F2]"
    >
      <div className="flex marquee-track whitespace-nowrap will-change-transform">
        {loop.map((w, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl tracking-tighter px-8 md:px-12"
          >
            {w}
            <span className="inline-block w-2 h-2 align-middle bg-[#FF3B30] ml-8 md:ml-12" />
          </span>
        ))}
      </div>
    </section>
  );
};
